import React from 'react';

import PropTypes from 'prop-types';

import Icon from '@/lib/components/Icon';
import styles from './InfoBlock.module.scss';

/**
 * This component is used to display a clean error message that can be readable by users.
 * It's mainly used for global errors not related to a particular form field and to display at the top op the window.
 */
const InfoBlock = ({ title = null, message = null }) => (
    <div className={styles.info_block}>
        <div className={styles.title}>
            <div className={styles.icon}>
                <Icon id="info" style={{ color: 'var(--primary, #0032fa)' }} />
            </div>
            <div className={styles.content}>
                {title}
            </div>
        </div>
        <div className={styles.message}>
            {message}
        </div>
    </div>
);

InfoBlock.propTypes = {
    /**
     * The title of the information block
     * */
    title: PropTypes.string,
    /**
     * The message to display in the information block
     * */
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

InfoBlock.displayName = 'InfoBlock';

export default InfoBlock;
